import { render, staticRenderFns } from "./reportsMain.vue?vue&type=template&id=21f1ed4d&scoped=true&"
import script from "./reportsMain.vue?vue&type=script&lang=js&"
export * from "./reportsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1ed4d",
  null
  
)

export default component.exports